import React, { Component } from 'react'
import {
  Switch,
  Route,
} from 'react-router-dom'
import { withRouter } from "react-router"
import { connect } from 'react-redux'
import {compose} from 'recompose'

import { BaseLayout } from './../Layout/'
import { appBody } from './../../styles'
import Router from './../../services/Router'

class AppRouter extends Component {

  componentWillReceiveProps({ location }) {
    if (location !== this.props.location) {
      document.querySelector('.app-body').scrollIntoView()
    }
  }

  render() {
    const { menu } = this.props
    
    return (
      <BaseLayout>
        <div className={`app-body ${appBody}`}>
          <Switch location={this.props.location}>
            {
              menu && menu.models.categories.map((category) => (
                category.menu.map((menu, index) => (
                  <Route path={ menu.url } component={ Router.catalog.component } exact key={index} />
                ))
              ))
            }
            {
              Object.keys(Router).map((route, index) => (
                <Route path={ Router[route].path } component={ Router[route].component } exact={Router[route].exact || false} key={index} />
              ))
            }
            <Route component={Router.home.component} />
          </Switch>
        </div>
      </BaseLayout>
    )
  }
}

const enhance = compose(
  withRouter,
  connect(
    ({ Session }) => ({
      menu: Session.menu,
    })
  )
)
export default enhance(AppRouter)


// WEBPACK FOOTER //
// ./src/scenes/Pages/index.js